import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})

export class FilterPipe implements PipeTransform {
  // If we're just filtering a list of strings, then 'propName' is not needed.
  // If we're filtering a list of objects and the search text applies to a specific field,
  // then pass that field name in as 'propName'.
  transform(items: any[], searchText: string, propName?: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter(it => {
      if (propName) {
        return it[propName].toLowerCase().includes(searchText);
      } else {
        return it.toLowerCase().includes(searchText);
      }
    });
  }
}
